var map = {
	"./gallery-wip-pommel_00.jpg": 4380,
	"./gallery-wip-pommel_01.jpg": 4381,
	"./gallery-wip-pommel_02.jpg": 4382,
	"./gallery-wip-pommel_03.jpg": 4383,
	"./gallery-wip-pommel_04.jpg": 4384,
	"./gallery-wip-pommel_05.jpg": 4385,
	"./gallery-wip-pommel_06.jpg": 4386,
	"./gallery_00.jpg": 4387,
	"./gallery_01.jpg": 4388,
	"./gallery_02.jpg": 4389,
	"./gallery_03.jpg": 4390,
	"./gallery_04.jpg": 4391,
	"./gallery_05.jpg": 4392,
	"./gallery_06.jpg": 4393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4379;